import script from "./batch-pay.vue?vue&type=script&lang=ts&setup=true"
export * from "./batch-pay.vue?vue&type=script&lang=ts&setup=true"

import "./batch-pay.vue?vue&type=style&index=0&id=64309acc&scoped=true&lang=stylus"

import exportComponent from "D:\\Repository\\Zidan\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64309acc"]])

export default __exports__